import React, { useState } from "react";
import {
  Callout,
  DefaultButton,
  Persona,
  PersonaSize,
  PrimaryButton,
  Text,
} from "office-ui-fabric-react";
import {
  btnS,
  btnsContainer,
  styles,
  subtitleContainer,
} from "../../styles/layout/userIcon.styles";
import { useUserData } from "../../../features/common/hooks/useUserData";
import { useDispatch } from "react-redux";
import { toggleSelfEditPanel } from "../../../config/redux/client/clientActions";
import authentication from "react-azure-b2c";
import { useTranslation } from "react-i18next";
import { IProfileUserPopUpLang } from "../../../localization/abstract/client/profile";

export interface UserIconProps { }

const UserIcon: React.FC<UserIconProps> = () => {
  const [isCalloutVisible, setIsCalloutVisible] = useState(false);
  const disptach = useDispatch()
  const { user } = useUserData();

  const handleCalloutVisibility = () => {
    setIsCalloutVisible(!isCalloutVisible);
  };

  const openSelfEditPanel = () => {
    disptach(toggleSelfEditPanel(true))
  };

  const logout = () => {
    sessionStorage.removeItem('role');
    sessionStorage.removeItem('isActivated');
    sessionStorage.removeItem('hasAllRequiredData');
    authentication.signOut();
  };
  const { t } = useTranslation("profile");
  const userPopUpNames: IProfileUserPopUpLang = t("userPopUp", {
    returnObjects: true,
  });
  return (
    <div>
      <div className={styles.buttonArea}>
        <Persona
          size={PersonaSize.size28}
          text={user ? user.name : ""}
          hidePersonaDetails={true}
          onClick={handleCalloutVisibility}
        />
      </div>
      {isCalloutVisible && (
        <Callout
          className={styles.callout}
          role="alertdialog"
          gapSpace={0}
          target={`.${styles.buttonArea}`}
          onDismiss={handleCalloutVisibility}
          setInitialFocus
        >
          <>
            <div className={styles.header}>
              <Text className={styles.title}>
                {user.name}
              </Text>
            </div>

            <div className={styles.inner}>
              <div className={subtitleContainer}>
                <Text className={styles.subtitle}>
                  {user.emails[0]}
                </Text>
              </div>
              <div className={btnsContainer}>
                <PrimaryButton styles={btnS} onClick={logout}>
                  {userPopUpNames.logout}
                </PrimaryButton>
                <DefaultButton styles={btnS} onClick={openSelfEditPanel}>
                  {userPopUpNames.profile}
                </DefaultButton>
              </div>
            </div>
          </>
        </Callout>
      )}
    </div>
  );
};

export default UserIcon;